import { useEffect, useState } from 'react';
import * as S from './styles'
import axios from 'axios';
import cogoToast from 'cogo-toast';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
 
function UserForm(props: any) {
 console.log("DEPLOY: 13:15")
    const {
        onSubmit,
        errors,
        register,
        watch,
        submitOnBlur,
        setValue,
        resetField,
        setError,
        checkUser,
        translationHome,
        clearErrors
    } = props
 
    const fields = watch()
 
    const [isCNPJ, setIsCNPJ] = useState(false);
    const [shortForm, setShortForm] = useState(true);
    const [showPassword, setShowPassword] = useState(true);
 
    useEffect(() => {
        const zipcode = fields?.zipcode?.replace(/[^a-zA-Z0-9\s]/g, '');
        setValue('zipcode', zipcode);
        if (!zipcode || zipcode?.length !== 8) {
            setShortForm(true);
        } else {
            fillAddress();
        }
    }, [fields.zipcode])
 
    useEffect(() => {
        const document = fields?.document?.replace(/[^a-zA-Z0-9\s]/g, '');
        setValue('document', document);
        const isCNPJ = fields?.document?.length === 14;
        setIsCNPJ(isCNPJ);
    }, [fields.document])
 
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = e.target;
 
        if (name === 'email') {
            clearErrors && clearErrors('email');
            setShowPassword(true);
            setValue('hasPassword', true);
        }
    };
 
    const fillAddress = async () => {
        const response = await axios.get(`https://viacep.com.br/ws/${fields.zipcode}/json/`);
        if (response.data.erro) {
            setError('zipcode', { message: 'CEP inválido' });
        }
        const { logradouro, localidade, uf, bairro } = response.data;
 
        setValue('address', logradouro)
        setValue('city', localidade)
        setValue('state', uf)
        setValue('district', bairro)
 
        setShortForm(false);
    }
 
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 13);
 
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 100);
 
    const emailSubmitOnBlurCustom = async () => {
 
        const result = checkUser && await checkUser(fields.email)
 
        const urlParams = new URLSearchParams(window.location.search)
        let planFromQuery = urlParams.get('plano')
        let periodFromQuery = urlParams.get('tipo')
        let mrcProduct = planFromQuery === 'crusoe' ? 'crs' : planFromQuery === 'antagonista' ? 'oam' : 'a+ccbo'
 
        if(result?.data?.product_access === 'cbo' || mrcProduct.includes(result?.data?.product_access) || result?.data.is_registered == true){
            setError('email', {message: 'E-mail já existe' })
            setShowPassword(false);
            setValue('hasPassword', false);
            resetField('password');
            resetField('confirmPassword');
            return
        }
 
        clearErrors && clearErrors('email')
        setShowPassword(true);
        setValue('hasPassword', true);
    }
 
    return (
        <>
            <S.Slug>{translationHome('HOME_SLUG')}</S.Slug>
            <S.Wrapper>
                <S.Title>Preencha as informações</S.Title>
                <S.Subtitle>a seguir para finalizar sua assinatura</S.Subtitle>
                <S.Form onSubmit={onSubmit}>
                    <S.Input name="email" placeholder="E-mail"
                        {...register('email', {
                            onChange: handleChange,
                            onBlur: () => { submitOnBlur && submitOnBlur(); emailSubmitOnBlurCustom(); }
                        })}
                    />
                    {errors?.email?.message ? <S.ErrorMessage>{errors?.email?.message}</S.ErrorMessage> : null}
                    {showPassword && (
                        <>
                            <S.InputPass name="password" placeholder="Senha" type="password" minLength={6} maxLength={100}
                                {...register("password", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.password?.message ? <S.ErrorMessage>{errors?.password?.message}</S.ErrorMessage> : null}
                            <S.InputPass name="confirmPassword" placeholder="Repita a senha" type="password" minLength={6} maxLength={100}
                                {...register("confirmPassword", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.confirmPassword?.message ? <S.ErrorMessage>{errors?.confirmPassword?.message}</S.ErrorMessage> : null}
                        </>
                    )}
                    <S.Input name="nome" placeholder="Nome e Sobrenome" minLength={3} maxLength={50}
                        {...register("name", {
                            onChange: handleChange,
                            onBlur: submitOnBlur
                        })}
                    />
                    {errors?.name?.message ? <S.ErrorMessage>{errors?.name?.message}</S.ErrorMessage> : null}
                    <S.Input
                        name="cnpjcpf"
                        placeholder="CPF/CNPJ"                        
                        type='text'
                        minLength={11} maxLength={50}
                        {...register("document", {
                            onChange: handleChange,
                            onBlur: submitOnBlur
                        })}
                    />
                    {errors?.document?.message ? <S.ErrorMessage>{errors?.document?.message}</S.ErrorMessage> : null}
                    <S.InputBirthdate
                        selected={typeof fields.birthdate === 'string' ? new Date(fields.birthdate) : fields.birthdate}
                        onChange={(date: Date) => setValue('birthdate', date)}
                        dateFormat="dd/MM/yyyy"
                        showYearDropdown
                        scrollableYearDropdown
                        maxDate={maxDate}
                        minDate={minDate}
                        dropdownMode='select'
                        placeholderText="Data de nascimento"
                        id="birthdate"
                        name="birthdate"
                    />
                    {errors?.birthdate?.message ? <S.ErrorMessage>{errors?.birthdate?.message}</S.ErrorMessage> : null}
                    {isCNPJ && <S.Input name="ie" placeholder="IE" minLength={6} maxLength={50}
                        {...register("ie", {
                            onChange: handleChange,
                            onBlur: submitOnBlur
                        })}
                    />}
                    {errors?.ie?.message ? <S.ErrorMessage>{errors?.ie?.message}</S.ErrorMessage> : null}
                    <S.InputMasked name="telefone" placeholder="+00(00)00000-0000" maskChar={null} alwaysShowMask={false} mask="+99999999999999"
                        {...register("phone", {
                            onChange: handleChange,
                            onBlur: () => { submitOnBlur(); }
                        })}
                    />
                    {errors?.phone?.message ? <S.ErrorMessage>{errors?.phone?.message}</S.ErrorMessage> : null}
                    <S.Input name="zipcode" placeholder="CEP" minLength={6} maxLength={50}
                        {...register("zipcode", {
                            onChange: handleChange,
                            onBlur: submitOnBlur
                        })} {...register('zipcode')}
                    />
                    {errors?.zipcode?.message ? <S.ErrorMessage>{errors?.zipcode?.message}</S.ErrorMessage> : null}
                    {!shortForm &&
                        <>
                            <S.Input name="address" placeholder="Endereço"
                                {...register("address", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.address?.message ? <S.ErrorMessage>{errors?.address?.message}</S.ErrorMessage> : null}
                            <S.Input name="district" placeholder="Bairro"
                                {...register("district", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.district?.message ? <S.ErrorMessage>{errors?.district?.message}</S.ErrorMessage> : null}
                            <S.Input name="number" placeholder="Número" type='number'
                                {...register("number", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.number?.message ? <S.ErrorMessage>{errors?.number?.message}</S.ErrorMessage> : null}
                            <S.Input name="complement" placeholder="Complemento"
                                {...register("complement", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.complement?.message ? <S.ErrorMessage>{errors?.complement?.message}</S.ErrorMessage> : null}
                            <S.DisabledInput name="city" placeholder="City" disabled
                                {...register("city", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.city?.message ? <S.ErrorMessage>{errors?.city?.message}</S.ErrorMessage> : null}
                            <S.DisabledInput name="state" placeholder="State" disabled
                                {...register("state", {
                                    onChange: handleChange,
                                    onBlur: submitOnBlur
                                })}
                            />
                            {errors?.state?.message ? <S.ErrorMessage>{errors?.zipcode?.message}</S.ErrorMessage> : null}
                        </>
                    }
                </S.Form>
            </S.Wrapper>
        </>
    );
}

export default UserForm
